<br />

<mat-vertical-stepper orientation="horizontal" [linear]="true" (selectionChange)="onStepChanged()">

  <ng-template matStepperIcon="edit">
    <mat-icon svgIcon="basics:edit"></mat-icon>
  </ng-template>

  @if(!isMitarbeiterRegistrierung() && !isPrueferRegistrierung()) {

    <mat-step>
      <ng-template matStepLabel>
        <span>{{ 'registrierung.stepper.firmendaten'|translate }}</span>
      </ng-template>
      <h1>{{ 'registrierung.stepper.ihre_firma'|translate }}</h1>
      <app-firmendaten [formGroupFirma]="formGroupFirmendaten"></app-firmendaten>
      <div class="flex-container-right bottom-navigation">
        <div>
          <button mat-button
                  class="registrierungButton forward"
                  (click)="weiterFirmendaten()">{{ 'registrierung.stepper.weiter'|translate }}</button>
        </div>
      </div>
    </mat-step>


    <mat-step>
      <ng-template matStepLabel>
        <span>{{ 'registrierung.stepper.benutzerdaten'|translate }}</span>
      </ng-template>
      <h1>{{ 'registrierung.stepper.benutzerdaten'|translate }}</h1>
      <app-benutzerdaten [formGroupBenutzer]="formGroupBenutzer"> </app-benutzerdaten>
      <hr />
      <app-zugangsdaten [formGroupZugangsdaten]="formGroupZugangsdaten"> </app-zugangsdaten>

      <div class="flex-container-right bottom-navigation">
        <div><button mat-button class="registrierungButton" matStepperPrevious>{{ 'registrierung.stepper.zurueck'|translate }}</button></div>
        <div>
          <button mat-button
                  class="registrierungButton forward"
                  (click)="weiterBenutzerdaten()">{{ 'registrierung.stepper.weiter'|translate }}</button>
        </div>
      </div>
    </mat-step>

    <mat-step>
      <h1>{{ 'registrierung.stepper.zustimmung_marktplatz'|translate }}</h1>
      <app-marktplatz-bedingungen
        [formGroupMarktplatzbedingungen]="formGroupMarktplatzbedingungen"
      ></app-marktplatz-bedingungen>
      <div class="flex-container-right bottom-navigation">
        <div><button mat-button class="registrierungButton" matStepperPrevious>{{ 'registrierung.stepper.zurueck'|translate }}</button></div>
        <div><button mat-button class="registrierungButton forward" matStepperNext>{{ 'registrierung.stepper.weiter'|translate }}</button></div>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>
        <span>{{ 'registrierung.stepper.lastschrift_zahlung'|translate }}</span>
      </ng-template>
      <h1>{{ 'registrierung.stepper.lastschrift_zahlung'|translate }}</h1>
      <app-lastschrift [formGroupLastschrift]="formGroupLastschrift"> </app-lastschrift>
      <div class="flex-container-right bottom-navigation">
        <div><button mat-button class="registrierungButton" matStepperPrevious>{{ 'registrierung.stepper.zurueck'|translate }}</button></div>
        @if (abschlussRegistrierungOK()) {
          <div><button (click)="registriereBenutzer()" mat-button class="registrierungButton forward" matStepperNext>Abschließen</button></div>
        } @else {
          <div><button mat-button [disabled]="true" class="registrierungButton_disabled" >{{ 'registrierung.stepper.weiter'|translate }}</button></div>
        }
      </div>
    </mat-step>
  }
  @if(isMitarbeiterRegistrierung()) {
    <mat-step>
      <ng-template matStepLabel>
        <span>{{ 'registrierung.stepper.einladung_ma'|translate }}</span>
      </ng-template>
      <div class="center_column">
        <div class="banner_column">
          {{'registrierung.start.willkommen' | translate}}
        </div>
        <div class="illustration_background">
          <img ngSrc="/assets/illustration_mitarbeiter.svg" alt="Mitarbeiter-Registrierung" width="86" height="64" priority/>
        </div>
      </div>
      @if(isUUIDGueltig()) {
        <div class="ma_registrierung_panel">
          <h1>{{ 'registrierung.stepper.herzlich_willkommen'|translate }}</h1>
          <h1>{{ 'registrierung.stepper.sie_wurden_eingeladen'|translate }}</h1>
          <div class="flex-container">
            <div style="flex: 12">
              <p>
                {{ 'registrierung.stepper.bitte_beachten'|translate }}
                <br />
                {{ 'registrierung.stepper.referenz_unternehmen'|translate }}
              </p>
              <label>{{ 'registrierung.stepper.unternehmen'|translate }}</label>
              <br />
              {{getEinladendeFirma()}}
              <br />
              <label>{{ 'registrierung.stepper.adresse'|translate }}</label>
              <br />
              {{getRegistrierungsdaten().firmendaten?.strasse}} {{getRegistrierungsdaten().firmendaten?.hausnummer}}
              {{getRegistrierungsdaten().firmendaten?.plz}} {{getRegistrierungsdaten().firmendaten?.ort}}
              @if (getRegistrierungsdaten().firmendaten?.telefon) {
                <br />
                <label>{{ 'registrierung.stepper.telefon'|translate }}</label>
                <br />
                {{getRegistrierungsdaten().firmendaten?.telefon}}
              }
            </div>
          </div>
        </div>
        <div class="flex-container-right bottom-navigation">
          <div><button mat-button class="registrierungButton forward" matStepperNext>{{ 'registrierung.stepper.weiter'|translate }}</button></div>
        </div>

      }
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>
        <span>{{ 'registrierung.stepper.benutzerdaten'|translate }}</span>
      </ng-template>
      <h1>{{ 'registrierung.stepper.benutzerdaten'|translate }}</h1>
      <app-benutzerdaten [formGroupBenutzer]="formGroupBenutzer"> </app-benutzerdaten>
      <hr />
      <app-zugangsdaten [formGroupZugangsdaten]="formGroupZugangsdaten"> </app-zugangsdaten>
      <div class="flex-container-right bottom-navigation">
        <div><button mat-button class="registrierungButton" matStepperPrevious>{{ 'registrierung.stepper.zurueck'|translate }}</button></div>
        <div>
          <button mat-button
                  class="registrierungButton forward"
                  (click)="weiterBenutzerdaten()">{{ 'registrierung.stepper.weiter'|translate }}</button>
        </div>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>
        <span>{{ 'registrierung.stepper.akzeptiere_agb'|translate }}</span>
      </ng-template>
      <app-agb [formGroupAGB]="formGroupAGB" typ="mitarbeiter"></app-agb>
      <div class="flex-container-right bottom-navigation">
        <div><button mat-button class="registrierungButton" matStepperPrevious>{{ 'registrierung.stepper.zurueck'|translate }}</button></div>
        @if(abschlussRegistrierungOK()) {
          <div><button mat-button (click)="registriereMitarbeiter()" class="registrierungButton forward" matStepperNext>{{ 'registrierung.stepper.registrierung_abschliessen'|translate }}</button></div>
        } @else {
          <div><button mat-button [disabled]="true" class="registrierungButton_disabled" >{{ 'registrierung.stepper.registrierung_abschliessen'|translate }}</button></div>
        }

      </div>
    </mat-step>
  }
  @if(isPrueferRegistrierung()) {
    <mat-step>
      <ng-template matStepLabel>
        <span>{{ 'registrierung.stepper.einladung_pruefer'|translate }}</span>
      </ng-template>
      <div class="center_column">
        <div class="banner_column">
          {{'registrierung.start.willkommen' | translate}}
        </div>
        <div class="illustration_background">
          <img ngSrc="/assets/illustration_pruefer.svg" alt="Prüfer-Registrierung" width="86" height="64" priority/>
        </div>
      </div>
      @if(isUUIDGueltig()) {
        <div class="ma_registrierung_panel">
          <h1>{{ 'registrierung.stepper.herzlich_willkommen'|translate }}</h1>
          <h1>{{ 'registrierung.stepper.sie_wurden_eingeladen_pruefer'|translate }}</h1>
          <div class="flex-container">
            <div style="flex: 12">
              <p>
                {{ 'registrierung.stepper.bitte_beachten'|translate }}
                <br />
                {{ 'registrierung.stepper.referenz_unternehmen_pruefer'|translate }}
              </p>
              <label>{{ 'registrierung.stepper.einladendes_unternehmen'|translate }}</label>
              <br />
              {{getEinladendeFirma()}}
              <br />
              <label>{{ 'registrierung.stepper.adresse'|translate }}</label>
              <br />
              {{getRegistrierungsdaten().firmendaten?.strasse}} {{getRegistrierungsdaten().firmendaten?.hausnummer}}
              <br />
              {{getRegistrierungsdaten().firmendaten?.plz}} {{getRegistrierungsdaten().firmendaten?.ort}}
              @if (getRegistrierungsdaten().firmendaten?.telefon) {
                <br />
                <label>{{ 'registrierung.stepper.telefon'|translate }}</label>
                <br />
                {{getRegistrierungsdaten().firmendaten?.telefon}}
              }
            </div>
          </div>
        </div>
        <div class="flex-container-right bottom-navigation">
          <div><button mat-button class="registrierungButton forward" matStepperNext>{{ 'registrierung.stepper.weiter'|translate }}</button></div>
        </div>

      }
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>
        <span>{{ 'registrierung.stepper.benutzerdaten'|translate }}</span>
      </ng-template>
      <h1>{{ 'registrierung.stepper.benutzerdaten'|translate }}</h1>
      <app-benutzerdaten [formGroupBenutzer]="formGroupBenutzer"> </app-benutzerdaten>
      <hr />
      <app-zugangsdaten [formGroupZugangsdaten]="formGroupZugangsdaten"> </app-zugangsdaten>
      <div class="flex-container-right bottom-navigation">
        <div><button mat-button class="registrierungButton" matStepperPrevious>{{ 'registrierung.stepper.zurueck'|translate }}</button></div>
        <div>
          <button mat-button
                  class="registrierungButton forward"
                  (click)="weiterBenutzerdaten()">{{ 'registrierung.stepper.weiter'|translate }}</button>
        </div>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>
        <span>{{ 'registrierung.stepper.akzeptiere_agb'|translate }}</span>
      </ng-template>
      <app-agb [formGroupAGB]="formGroupAGB" typ="pruefer"></app-agb>
      <div class="flex-container-right bottom-navigation">
        <div><button mat-button class="registrierungButton" matStepperPrevious>{{ 'registrierung.stepper.zurueck'|translate }}</button></div>
        @if(abschlussRegistrierungOK()) {
          <div><button mat-button (click)="registrierePruefer()" class="registrierungButton forward" matStepperNext>{{ 'registrierung.stepper.registrierung_abschliessen'|translate }}</button></div>
        } @else {
          <div><button mat-button [disabled]="true" class="registrierungButton_disabled" >{{ 'registrierung.stepper.registrierung_abschliessen'|translate }}</button></div>
        }

      </div>
    </mat-step>
  }

  <mat-step>
    <ng-template matStepLabel>
      <span>{{ 'registrierung.stepper.zusammenfassung'|translate }}</span>
    </ng-template>
    <app-zusammenfassung [formGroupZusammenfassung]="formZusammenfassung"></app-zusammenfassung>
  </mat-step>
</mat-vertical-stepper>
